import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ConsentRequest {
    slug: string;
    status: string;
}

export interface ConsentResponse {
    success: boolean;
    status: string;
}

interface ConsentState {
    loading: boolean;
    error: string | null;
    data: ConsentResponse | null;
}

const initialState: ConsentState = {
    loading: false,
    error: null,
    data: null,
};

const consentSlice = createSlice({
    name: "consent",
    initialState,
    reducers: {
        updateConsentRequest: (
            state,
            _action: PayloadAction<ConsentRequest>
        ) => {
            state.loading = true;
            state.error = null;
        },

        updateConsentSuccess: (
            state,
            action: PayloadAction<ConsentResponse>
        ) => {
            state.loading = false;
            state.data = action.payload;
        },

        updateConsentFailure: (
            state,
            action: PayloadAction<string>
        ) => {
            state.loading = false;
            state.error = action.payload;
        },

        clearConsentState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = null;
        },
    },
});

export const {
    updateConsentRequest,
    updateConsentSuccess,
    updateConsentFailure,
    clearConsentState,
} = consentSlice.actions;

export const consentReducer = consentSlice.reducer;
export const consentActionTypes = consentSlice.actions;